export default __webpack_public_path__ + "media/images/indent-left-white-6d1af8b423936b4c44f06ebea09d1881.png";